import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IGhatReceipt, IGhatReceiptInitialState } from "./ghatReceiptModel";
import {
  createGhatReceipt,
  deleteGhatReceipt,
  findAllGhatReceipt,
  findByOrderNoGhatReceipt,
  getAllOrderGhatIssue,
  getGhatReceiptById,
  updateGhatReceipt,
} from "./services/gharteceipt.services";

const initialState: IGhatReceiptInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  GhatIssueOrderList: [],
  GhatReceiptList: [],
  GhatReceiptID: null,
  GhatReceiptOrderSave: false,
  OrderDetailsGhat: {
    order_no: null,
    item_id: null,
    ghat_id: null,
    item_name: "",
    item_description: "",
    item_category_id: null,
    weight: null,
    purity: null,
  },
  GhatReceiptDetail: {
    karigar_name: "",
    karigar_id: null,
    receipt_date: new Date(),
    ghat_receipt_order: [],
  },
  FilterGhatReceipt: {
    karigar_name: "",
    karigar_nick_name: "",
    receipt_date: "",
  },
  GhatReceiptOrderItemIndex: -1,
  GhatReceiptApprovalItemIndex: -1,
  GhatReceiptUsedByKarigarItemIndex: -1,
  ApprovalItemDeleteConfirmDialog: false,
  KarigarItemDeleteConfirmDialog: false,
  SelectItemDialog: false,
  GhatReceiptOrderDialogOpenIndex: null,
  GhatReceiptChecklistDialog: false,
  GhatReceiptViewImageDialog: false,
  GhatReceiptPreviousDetails: null,
};

const ghatReceiptSlice = createSlice({
  name: "ghatreceipt",
  initialState,
  reducers: {
    clearGhatReceiptDetail: (state) => {
      state.GhatReceiptDetail = initialState.GhatReceiptDetail;
    },
    setGhatReceiptID: (state, action) => {
      state.GhatReceiptID = action.payload;
    },
    setGhatReceiptOrderSave: (state, action) => {
      state.GhatReceiptOrderSave = action.payload;
    },
    setGhatReceiptOrderDialogOpenIndex: (state, action) => {
      state.GhatReceiptOrderDialogOpenIndex = action.payload;
    },
    clearGhatReceiptID: (state) => {
      state.GhatReceiptID = null;
    },
    setFilterGhatReceipt: (state, action) => {
      state.FilterGhatReceipt = action.payload;
    },
    clearFilterGhatReceipt: (state) => {
      state.FilterGhatReceipt = initialState.FilterGhatReceipt;
    },

    setGhatReceiptOrderItemIndex: (state, action) => {
      state.GhatReceiptOrderItemIndex = action.payload;
    },
    setGhatReceiptApprovalItemIndex: (state, action) => {
      state.GhatReceiptApprovalItemIndex = action.payload;
    },
    setGhatReceiptUsedByKarigarItemIndex: (state, action) => {
      state.GhatReceiptUsedByKarigarItemIndex = action.payload;
    },
    openApprovalItemDeleteConfirmDialog: (state) => {
      state.ApprovalItemDeleteConfirmDialog = true;
    },
    closeApprovalItemDeleteConfirmDialog: (state) => {
      state.ApprovalItemDeleteConfirmDialog = false;
    },
    openKarigarItemDeleteConfirmDialog: (state) => {
      state.KarigarItemDeleteConfirmDialog = true;
    },
    closeKarigarItemDeleteConfirmDialog: (state) => {
      state.KarigarItemDeleteConfirmDialog = false;
    },
    openSelectItemDialog: (state) => {
      state.SelectItemDialog = true;
    },
    closeSelectItemDialog: (state) => {
      state.SelectItemDialog = false;
    },
    openGhatReceiptChecklistDialog: (state) => {
      state.GhatReceiptChecklistDialog = true;
    },
    closeGhatReceiptChecklistDialog: (state) => {
      state.GhatReceiptChecklistDialog = false;
    },

    setGhatReceiptPreviousDetails: (state, action) => {
      state.GhatReceiptPreviousDetails = action.payload;
    },
    clearGhatReceiptPreviousDetails: (state) => {
      state.GhatReceiptPreviousDetails =
        initialState.GhatReceiptPreviousDetails;
    },
    openGhatReceiptViewImageDialog: (state) => {
      state.GhatReceiptViewImageDialog = true;
    },
    closeGhatReceiptViewImageDialog: (state) => {
      state.GhatReceiptViewImageDialog = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findAllGhatReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllGhatReceipt.fulfilled,
      (state, action: PayloadAction<IGhatReceipt[]>) => {
        state.loading = false;
        state.GhatReceiptList = action.payload || [];
      },
    );
    builder.addCase(findAllGhatReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.GhatReceiptList = [];
    });

    builder.addCase(createGhatReceipt.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createGhatReceipt.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createGhatReceipt.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateGhatReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateGhatReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateGhatReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteGhatReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteGhatReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteGhatReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getGhatReceiptById.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getGhatReceiptById.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.GhatReceiptDetail = action.payload;
    });
    builder.addCase(getGhatReceiptById.rejected, (state, action) => {
      state.formLoading = false;
      state.GhatReceiptDetail = initialState.GhatReceiptDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(findByOrderNoGhatReceipt.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(
      findByOrderNoGhatReceipt.fulfilled,
      (state, action: any) => {
        state.formLoading = false;
        state.OrderDetailsGhat = action.payload;
      },
    );
    builder.addCase(findByOrderNoGhatReceipt.rejected, (state, action) => {
      state.formLoading = false;
      state.OrderDetailsGhat = initialState.OrderDetailsGhat;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllOrderGhatIssue.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAllOrderGhatIssue.fulfilled, (state, action) => {
      state.loading = false;
      state.GhatIssueOrderList = action.payload || [];
    });
    builder.addCase(getAllOrderGhatIssue.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.GhatIssueOrderList = initialState.GhatIssueOrderList;
    });
  },
});

export const {
  clearGhatReceiptDetail,
  clearGhatReceiptID,
  setGhatReceiptID,
  clearFilterGhatReceipt,
  setFilterGhatReceipt,
  setGhatReceiptOrderItemIndex,
  setGhatReceiptApprovalItemIndex,
  setGhatReceiptUsedByKarigarItemIndex,
  closeApprovalItemDeleteConfirmDialog,
  closeKarigarItemDeleteConfirmDialog,
  closeSelectItemDialog,
  openApprovalItemDeleteConfirmDialog,
  openKarigarItemDeleteConfirmDialog,
  openSelectItemDialog,
  setGhatReceiptOrderDialogOpenIndex,
  setGhatReceiptOrderSave,
  closeGhatReceiptChecklistDialog,
  openGhatReceiptChecklistDialog,
  clearGhatReceiptPreviousDetails,
  setGhatReceiptPreviousDetails,
  openGhatReceiptViewImageDialog,
  closeGhatReceiptViewImageDialog,
} = ghatReceiptSlice.actions;
export default ghatReceiptSlice.reducer;
